const SEEN_KEY = "ns.companion.acars.seen";

export function loadSeenAcars(storage: Pick<Storage, "getItem"> | null | undefined): string[] {
  if (!storage) return [];
  try {
    const raw = JSON.parse(storage.getItem(SEEN_KEY) || "[]") as unknown;
    if (!Array.isArray(raw)) return [];
    return raw.filter((row) => typeof row === "string" && row.length > 0 && row.length < 80).slice(-200);
  } catch {
    return [];
  }
}

export function saveSeenAcars(storage: Pick<Storage, "setItem"> | null | undefined, ids: readonly string[]): void {
  if (!storage) return;
  try {
    storage.setItem(SEEN_KEY, JSON.stringify([...ids].slice(-200)));
  } catch {
    /* private mode */
  }
}

export function unreadAcarsIds(ids: readonly string[], seen: readonly string[]): string[] {
  const have = new Set(seen);
  return ids.filter((id) => !have.has(id));
}

/** Two short tones. No-ops where the browser audio API is absent, including node tests. */
export function playSelcal(): void {
  const host = typeof globalThis === "undefined" ? undefined : (globalThis as { AudioContext?: typeof AudioContext });
  const Ctx = host?.AudioContext;
  if (!Ctx) return;
  try {
    const ctx = new Ctx();
    const now = ctx.currentTime;
    for (const [index, freq] of [880, 660].entries()) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const start = now + index * 0.18;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.05, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.16);
      osc.start(start);
      osc.stop(start + 0.17);
    }
    const closer = () => void ctx.close();
    if (typeof window !== "undefined" && typeof window.setTimeout === "function") window.setTimeout(closer, 700);
  } catch {
    /* audio blocked */
  }
}
